import { useNavigate, useParams } from 'react-router-dom'
import AsignacionForm from '@/features/almacen/components/AsignacionForm'
import type { AsignacionFormPayload } from '@/features/almacen/components/AsignacionForm'
import { reasignarOAsignar } from '@/features/almacen/api/movimientos.api'

/**
 * Reasignación de una herramienta. El id viene de la ruta.
 *
 * `volverA` existe porque se llega desde dos listados, Asignación y Devolución,
 * y hay que regresar al que corresponde.
 */
const ReasignarPage = ({ volverA = '/almacen/asignacion' }: { volverA?: string }) => {
  const navigate = useNavigate()
  const { id = '' } = useParams<{ id: string }>()

  const guardar = async (payload: AsignacionFormPayload) => {
    await reasignarOAsignar(id, {
      projectId:         payload.projectId,
      responsibleUserId: payload.responsibleUserId,
      warehouseId:       payload.warehouseId,
      notes:             payload.notes,
      evidenceUrl1:      payload.evidenceUrl1,
      evidenceUrl2:      payload.evidenceUrl2,
      evidenceUrl3:      payload.evidenceUrl3,
    })
    navigate(volverA)
  }

  return (
    <AsignacionForm
      mode="reasignar"
      toolId={id}
      onBack={() => navigate(volverA)}
      onSubmit={guardar}
    />
  )
}

export default ReasignarPage
